import CommonTableWrapper from 'components/CommonTableWrapper/CommonTableWrapper'
import dayjs from 'utils/dayjs';
import React, { Component } from 'react'
import { Button, Modal } from 'react-bootstrap'
import WithAlert from "hoc/WithAlert";
import { uepClient } from 'uepClient';
import { tableIcons } from 'utils/MaterialTableHelper';
import colors from "styles/colors.module.scss";
import { FilterTextName, QueryStatus, TableTitle, getFileScenario } from 'constants/UserConstants'
import "./AgentRaiseQuery.scss"
import { getUser, getUsername } from 'utils/Common';
import Select from "react-select";
import TableToolbar from 'components/AgentTableToolbar/TableToolbar';

const DATE_FORMAT = "DD MMM YYYY hh:mm a";
const endDate = dayjs().endOf('day').utc().format().toString();
const startDate = dayjs().startOf('day').utc().format().toString();

const assignStatus = [{
    label: QueryStatus.NOT_STARTED,
    status: QueryStatus.NOT_STARTED
}, {
    label: QueryStatus.CLOSED,
    status: QueryStatus.CLOSED
}, {
    label: QueryStatus.WORK_IN_PROGRESS,
    status: QueryStatus.WORK_IN_PROGRESS
}]

export class AgentRaiseQuery extends Component {
    constructor() {
        super();
        this.state = {
            isLoading: false,
            querys: [],
            selectedRows: [],
            searchText: "",
            showPopUp: false,
            detailQuery: null,
            isEditMode: false,
            startDate: startDate,
            endDate: endDate,
            userName: getUsername(),
            queryId: null,
            queryAssignStatus: null,
            selectedQuery: null,
            status: assignStatus[0],
            assignedTo: "",
            filteredAgentID: "",
            detailQueryImage: null,
            isGetImageLoading: false
        };
    }

    componentDidMount() {
        this.fetchAllQuery(startDate, endDate)
    }

    render() {
        const { isLoading, showPopUp } = this.state
        return (

            <div className="agent-content">
                <div className="agent-list-table-container">
                    <div className="table-wrapper">
                        {this.renderTableToolbar()}
                        <CommonTableWrapper
                            icons={tableIcons}
                            columns={this.getTableColumns()}
                            data={this.getQuerysData()}
                            isLoading={isLoading}
                            emptyMessage="No queries found."
                        />
                    </div>
                </div>
                <Modal
                    className="detailed-info-modal"
                    centered
                    onHide={this.closeModalPopup}
                    show={showPopUp}
                >
                    {this.renderQuery()}
                </Modal>
            </div>


        )
    }

    fetchAllQuery = (startDate, endDate) => {

        const { status, filteredAgentID } = this.state
        this.setState({ isLoading: true });

        uepClient()
            .get(`/customer-query?fromDateTime=${startDate}&toDateTime=${endDate}${status ? `&status=${status.status}` : ``}${filteredAgentID != "" ? `&assignedTo=${filteredAgentID}` : ``}`)
            .then((res) => {
                this.setState({
                    querys: res.data,
                    isLoading: false,
                });
            })
            .catch((err) => {
                console.error(`Failed to fetch list of Query  : ${err}`);
                // Resetting to default state 
                this.setState({
                    querys: [],
                    isLoading: false,
                });
                this.props.showAlert({
                    variant: "danger",
                    content: (
                        <span>
                            <b>Error!</b> Failed to fetch the list of Querys, please try again.
                        </span>
                    ),
                });
            });
    };



    renderTableToolbar = () => {
        const { startDate, endDate, searchText, status, filteredAgentID, querys } = this.state
        return (
            <TableToolbar
                searchValue={searchText}
                onSearchTextChange={this.onSearchTextChange}
                onDateChage={this.onDateChage}
                startDate={startDate}
                endDate={endDate}
                onRefreshClick={this.onRefreshClick}
                isButton={false}
                filterButtonText={FilterTextName.FilterQuery}
                onRecentData={this.onRecentQuery}
                statusDropDownList={assignStatus}
                selectedStatus={status}
                title={TableTitle.RaiseQuery}
                onStatusChange={this.onFilterStatusChange}
                agentId={filteredAgentID}
                onAgentIdSearch={this.onAgentIdSearch}
                tableDataCount={querys.length}
            />
        );
    };

    getTableColumns = () => {
        const tableColumns = [
            {
                title: "Customer ID",
                field: "customerId",
                filtering: false,
                sorting: true,
            },
            {
                title: "Phone Number",
                field: "mobileNumber",
                filtering: true,
            },
            {
                title: "Query",
                field: "query",
                filtering: false,
                render: (rowData) => {
                    return (<span className='long-description'>{rowData?.query}</span>)
                },
            },
            {
                title: "Status",
                field: "status",
                filtering: false,
            },
            {
                title: "AssignedTo",
                field: "assignedTo",
                filtering: false,
                render: (rowData) => {
                    if (rowData.assignedTo != null) {
                        return <span>{rowData.assignedTo}</span>
                    } else {
                        return <Button className="view-opty-btn" onClick={(e) =>
                            this.onAssignToMe({ id: rowData.id, status: QueryStatus.NOT_STARTED })}>Assign To Me</Button>
                    }
                },
            },
            {
                title: "Created Date",
                field: "createdAt",
                defaultSort: "desc",
                render: (rowData) => {
                    return dayjs(rowData.createdAt).format(DATE_FORMAT)
                },
            },
            {
                title: "Updated Date",
                field: "updatedAt",
                defaultSort: "desc",
                render: (rowData) => {
                    return dayjs(rowData.updatedAt).format(DATE_FORMAT)
                },
            },
            {
                title: "View Query",
                filtering: false,
                sorting: false,
                render: rowData => <Button
                    className="view-details-btn"
                    label="View"
                    onClick={(e) => this.openModalPopup(rowData)}
                >View</Button>
            },
        ];

        const tableColumnsWithStyle = tableColumns.map((tc) => ({
            ...tc,
            cellStyle: {
                border: 0,
                color: colors.darkGrey,
                fontWeight: "normal",
            },
            headerStyle: {
                border: 0,
                color: colors.darkGrey,
                fontWeight: "500",
                fontSize: "1em",
            },
        }));
        return tableColumnsWithStyle;
    };

    renderQuery = () => {
        const { detailQuery, queryId, queryAssignStatus, selectedQuery, detailQueryImage, isGetImageLoading } = this.state
        return (detailQuery &&
            <div className='main-modal-card'>
                <div className='flex-card'>
                    <div className='user-detail'>
                        <label>Customer Id : </label>
                        <span>{detailQuery.customerId ? detailQuery.customerId : "NA"}  </span>
                    </div>
                    <div className='user-detail'>
                        <label>Mobile Number: </label>
                        <span>{detailQuery.mobileNumber ? detailQuery.mobileNumber : "NA"}</span>
                    </div>
                </div>
                <div className='flex-card'>
                    <div className='user-detail'>
                        <label>Customer Query : </label>
                        <span className='user-query'>{detailQuery.query ? detailQuery.query : "NA"}</span>
                    </div>
                    <div className='user-detail'>
                        <label>Image : </label>
                        <span>{detailQuery.imageId ?
                            isGetImageLoading ?
                                "NA"
                                :
                                detailQueryImage ?
                                    <img src={detailQueryImage}
                                        key="QueryImage"
                                        data-tip="Query Image"
                                        data-for="channelTip"
                                    />
                                    :
                                    "NA"
                            : "NA"} </span>
                    </div>
                </div>
                <div className='flex-card'>
                    <div className='user-detail'>
                        <label>AssignedTo : </label>
                        {detailQuery.assignedTo ?
                            <span>{detailQuery.assignedTo}</span>
                            : queryId == detailQuery.id ?
                                <Button
                                    className="view-details-btn selected"
                                    label="Close"
                                    onClick={e => this.setState({
                                        queryId: null
                                    })}
                                >Assigned To You</Button> :
                                <Button
                                    className="view-details-btn"
                                    label="Close"
                                    onClick={e => this.setState({
                                        queryId: detailQuery.id
                                    })}
                                >Assign To Me</Button>}
                    </div>
                    <div className='user-detail'>
                        <label>Status : </label>
                        <Select
                            onChange={this.onStatusChange}
                            value={queryAssignStatus ? queryAssignStatus : selectedQuery}
                            options={assignStatus}
                            placeholder="Select Status"
                            styles={this.getDropdownStyles()}
                        />
                    </div>
                </div>
                <div className='flex-card'>
                    <div className='user-detail'>
                        <label>Created Date : </label>
                        <span>{detailQuery.createdAt ? dayjs(detailQuery.createdAt).format(DATE_FORMAT) : "NA"}</span>
                    </div>
                    <div className='user-detail'>
                        <label>Updated Date : </label>
                        <span>{detailQuery.updatedAt ? dayjs(detailQuery.updatedAt).format(DATE_FORMAT) : "NA"}</span>
                    </div>
                </div>

                <div className='modal-footer'>
                    {detailQuery &&
                        <>
                            <Button
                                disabled={queryId == null && detailQuery.assignedTo == null ? true : ''}
                                className="form-agent-btn save-btn "
                                label="Close"
                                onClick={this.onModalSave}
                            >
                                save
                            </Button>
                        </>
                    }
                    <Button
                        className="form-agent-btn cancel-btn "
                        label="Close"
                        onClick={this.closeModalPopup}
                    >
                        Close
                    </Button>
                </div>
            </div>
        )
    }

    onStatusChange = (selectedChannels) => {
        this.setState({
            queryAssignStatus: selectedChannels,
        })
    };

    onModalSave = () => {
        const { queryAssignStatus, queryId, status } = this.state
        this.onAssignToMe({ id: queryId ? queryId : this.state.detailQuery.id, status: queryAssignStatus ? queryAssignStatus.status : status.status })
    }

    onAssignToMe = (item) => {
        const { startDate, endDate } = this.state
        const { id, status } = item

        const Body = {
            status: status,
            assignedTo: this.state.userName,
            updatedBy: this.state.userName
        }

        uepClient()
            .put(`/customer-query/${id}`, Body)
            .then((res) => {
                this.setState({
                    isLoading: false,
                });
                this.closeModalPopup()
                this.fetchAllQuery(startDate, endDate)

            })
            .catch((err) => {
                console.error(`Failed to assign query  : ${err}`);
                // Resetting to default state 
                this.setState({
                    isLoading: false,
                });
                this.closeModalPopup()
                this.props.showAlert({
                    variant: "danger",
                    content: (
                        <span>
                            <b>Error!</b> Failed to assign Query, please try again.
                        </span>
                    ),
                });
            });
    }

    getImage = async (item) => {
        this.setState({
            isGetImageLoading: true
        })

        await uepClient()
            .get(`/file?fileId=${item}&scenario=${getFileScenario.CUSTOMER_QUERY}`)
            .then((res) => {
                this.setState({
                    detailQueryImage: res.data.fileUrl,
                    isGetImageLoading: false,
                })
            })
            .catch((err) => {
                console.error(`Failed to fetch image  : ${err}`);
                // Resetting to default state 

                this.setState({
                    isGetImageLoading: false,
                    detailQueryImage: null,

                });
                this.props.showAlert({
                    variant: "danger",
                    content: (
                        <span>
                            <b>Error!</b> Failed to fetch the Image, please try again.
                        </span>
                    ),
                });
                return
            });
    }

    onSearchTextChange = (searchText) => {
        this.setState({
            searchText,
        });
    };
    onAgentIdSearch = (searchText) => {
        this.setState({
            filteredAgentID: searchText,
        });
    };
    getQuerysData = () => {
        const { querys, searchText } = this.state;
        return searchText.trim().length
            ? querys.filter((row) => this.validateSearch(row))
            : querys;
    };
    validateSearch = (row) => {
        const { searchText } = this.state;
        const searchLc = searchText.toLowerCase();
        const customerIdValidator = row.customerId.toLowerCase().includes(searchLc);
        const phoneNumberValidator = row.mobileNumber.toLowerCase().includes(searchLc);
        const queryValidator = row.query.toLowerCase().includes(searchLc);
        const assignedUserValidator = row.assignedTo?.toLowerCase().includes(searchLc);
        const createdDateValidator =
            dayjs(row.createdAt)
                .format(DATE_FORMAT)
                .toString()
                .toLowerCase()
                .includes(searchLc)
        const updatedDateValidator =
            dayjs(row.updatedAt)
                .format(DATE_FORMAT)
                .toString()
                .toLowerCase()
                .includes(searchLc)

        return (customerIdValidator || phoneNumberValidator || queryValidator || createdDateValidator || updatedDateValidator || assignedUserValidator)
    };

    getDropdownStyles = () => {
        const customStyles = {
            container: (provided) => ({
                ...provided,
                width: "100%",
            }),
            control: (provided, { isDisabled }) => ({
                ...provided,
                width: "100%",
                minWidth: 120,
                height: 34,
                minHeight: 34,
                font: "normal normal bold 14px/19px Roboto",
                background: "white",
                paddingLeft: "0px",
                opacity: isDisabled ? 0.5 : 1,
                boxShadow: "0px 3px 6px #00000029",
                border: 0,
            }),
            option: (provided) => ({
                ...provided,
                background: "#fff",
                color: "#000",
                width: "100%",
                minWidth: 120,
                font: "Roboto",
                border: "none",
            }),
            dropdownIndicator: (provided, state) => ({
                ...provided,
                width: 28,
                paddingTop: 0,
                paddingBottom: 0,
                color: "#3c3c3f",
                transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : null,
            }),
            multiValue: (provided) => ({
                ...provided,
                fontFamily: "Roboto",
                color: "#96969B",
            }),
            multiValueRemove: (provided) => ({
                ...provided,
                color: "#96969B",
                "&:hover": {
                    backgroundColor: "#3A8AFA",
                    color: "#fff",
                },
            }),
            menu: (provided) => ({
                ...provided,
            }),
            placeholder: (provided) => ({
                ...provided,
                fontWeight: "normal",
            }),
        };
        return customStyles;
    };

    openModalPopup = (item) => {
        if (item.imageId !== null) {
            this.getImage(item.imageId)
        }
        assignStatus.map((statusItem) => {
            if (statusItem.status === item.status) {
                this.setState({
                    selectedQuery: statusItem
                })
            }
        })

        this.setState({
            showPopUp: true,
            detailQuery: item,
        })
    }
    // Close Popup modal
    closeModalPopup = () => {
        this.setState({
            showPopUp: false,
            detailQuery: null,
            queryAssignStatus: '',
            queryId: null,
            detailQueryImage: null,
            isGetImageLoading: null
        })
    }

    onDateChage = (date) => {
        const changeStartDate = date.startDate ? dayjs(date.startDate).utc().format().toString() : this.state.startDate;
        const changeEndDate = date.endDate ? dayjs(date.endDate).utc().format().toString() : this.state.endDate;
        this.setState({
            startDate: changeStartDate,
            endDate: changeEndDate
        });
    }

    onFilterStatusChange = (date) => {
        this.setState({
            status: date
        });
    }


    onRecentQuery = () => {
        const { startDate, endDate } = this.state

        this.fetchAllQuery(startDate, endDate)
    }

    onRefreshClick = () => {
        this.setState({
            startDate: startDate,
            endDate: endDate,
            status: assignStatus[0],
            filteredAgentID: "",
        })
        this.fetchAllQuery(startDate, endDate)
    }
}

export default WithAlert(AgentRaiseQuery)